// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer_2Jpsb","textArea":"Footer_textArea_1eMb4","linkBtn":"Footer_linkBtn_3bgwB","copyright":"Footer_copyright_6Xrdg","cookieConsent":"Footer_cookieConsent_3q6GY"};